import type { DashboardViewsDto } from '@/api/dashboard-views.api'

import { normalizePositions, type DashboardViewsState } from '../model/dashboardViews'

export const toDashboardViewsState = (dto: DashboardViewsDto): DashboardViewsState => ({
  activeViewId: dto.activeViewId,
  views: dto.views.map((view) => ({
    ...view,
    deviceIds: [...view.deviceIds],
    positions: normalizePositions(view.deviceIds, view.positions),
  })),
})

export const toDashboardViewsDto = (state: DashboardViewsState): DashboardViewsDto => ({
  activeViewId: state.activeViewId,
  views: state.views.map((view) => ({
    ...view,
    deviceIds: [...view.deviceIds],
    positions: normalizePositions(view.deviceIds, view.positions),
  })),
})
